<script>
    import MainMenu from './sidebar/main-menu.svelte';
    import SocialLinks from './sidebar/social-links.svelte';
    import ArrowsNav from './sidebar/arrows-nav.svelte';
    import Spotify from './sidebar/spotify.svelte';
    import store from '../state';

    let isOpen = $state(false);
    function toggleOpen() {
        isOpen = !isOpen;
    }

    let lastPage = null;

    function onPageChange() {
        if (lastPage == $store.page) {
            return;
        }

        lastPage = $store.page;

        isOpen = false;
        console.log('Page changed');
    }

    $effect(() => onPageChange($store.page));
</script>

<style>
    @media only screen and (max-width: 1024px) {
        .header {
            display: inline-flex;
            flex-direction: column;
            position: absolute;
            width: 100%;
            max-width: 330px;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: #444;
            z-index: 99;
            padding: 30px 30px 10px 30px;
            text-align: center;
            opacity: 1;
            visibility: visible;
            overflow: auto;
            -webkit-transition: all .25s ease-in-out;
            -moz-transition: all .25s ease-in-out;
            -o-transition: all .25s ease-in-out;
            -ms-transition: all .25s ease-in-out;
            transition: all .25s ease-in-out;
        }

        .header-titles h2 {
            font-size: 30px;
            margin-bottom: 10px;
        }

        .header-titles h4 {
            font-size: 17px;
        }

        .header-photo {
            max-width: 130px;
            margin-bottom: 25px;
        }

        .mobile-menu-hide {
            width: 0;
            right: 0;
            margin-right: -100%;
            overflow: hidden;
            opacity: 0;
            visibility: hidden;
            -webkit-box-shadow: none;
            -moz-box-shadow: none;
            box-shadow: none;
        }

        .menu-toggle {
            position: absolute;
            display: block;
            width: 48px;
            height: 48px;
            line-height: 46px;
            text-align: center;
            background-color: #5050f5;
            right: 10px;
            font-size: 19px;
            top: 10px;
            border-radius: 30px;
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: .5s ease-in-out;
            -moz-transition: .5s ease-in-out;
            -o-transition: .5s ease-in-out;
            transition: .5s ease-in-out;
            cursor: pointer;
            z-index: 900;
        }

        .menu-toggle span {
            display: block;
            position: absolute;
            height: 3px;
            width: 50%;
            background: #fff;
            border-radius: 5px;
            opacity: 1;
            left: 25%;
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: .25s ease-in-out;
            -moz-transition: .25s ease-in-out;
            -o-transition: .25s ease-in-out;
            transition: .25s ease-in-out;
        }

        .menu-toggle span:nth-child(1) {
            top: 16px;
            -webkit-transform-origin: left center;
            -moz-transform-origin: left center;
            -o-transform-origin: left center;
            transform-origin: left center;
        }

        .menu-toggle span:nth-child(2) {
            top: 22px;
            -webkit-transform-origin: left center;
            -moz-transform-origin: left center;
            -o-transform-origin: left center;
            transform-origin: left center;
        }

        .menu-toggle span:nth-child(3) {
            top: 28px;
            -webkit-transform-origin: left center;
            -moz-transform-origin: left center;
            -o-transform-origin: left center;
            transform-origin: left center;
        }

        .menu-toggle.open span:nth-child(1) {
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 13px;
            left: 15px;
        }

        .menu-toggle.open span:nth-child(2) {
            width: 0%;
            opacity: 0;
        }

        .menu-toggle.open span:nth-child(3) {
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            transform: rotate(-45deg);
            top: 30px;
            left: 15px;
        }
    }

    @media only screen and (min-width: 1025px) {
        .header {
            display: inline-flex;
            flex-direction: column;
            float: left;
            width: 100%;
            max-width: 380px;
            height: 100%;
            max-height: 80vh;
            min-height: inherit;
            text-align: center;
            padding: 70px 30px 45px;
            overflow: auto;
        }

        .header-titles {}
    }

    @media only screen and (max-width: 1280px) {
        .header {
            max-width: 330px;
        }

        .header-photo {
            max-width: 100%;
        }
    }

    .header-photo {
        position: relative;
        width: 180px;
        margin: 0 auto 30px;
        z-index: 1;
    }

    .header-photo:before {
        content: '';
        display: block;
        width: 180px;
        height: 180px;
        border: 3px solid #fff;
        border-radius: 300px;
        background: #fff url(/img/main_photo.png) center center no-repeat;
        background-size: 100%;
    }

    .header-photo:after {
        position: absolute;
        opacity: 0.3;
        top: 7%;
        left: 7%;
        border-radius: 300px;
        content: '';
        height: calc(100% + 0px);
        width: calc(100% + 0px);
        background-image: -webkit-repeating-radial-gradient(center center, #fff, #fff 1px, transparent 0px, transparent 100%);
        background-image: -moz-repeating-radial-gradient(center center, #fff, #fff 1px, transparent 0px, transparent 100%);
        background-image: -ms-repeating-radial-gradient(center center, #fff, #fff 1px, transparent 0px, transparent 100%);
        -webkit-background-size: 6px 6px;
        -moz-background-size: 6px 6px;
        background-size: 6px 6px;
        z-index: -1;
    }

    .header-titles h2 {
        font-size: 36px;
        font-weight: 600;
        color: #f5f5f5;
        margin: 5px 0 7px;
        line-height: 1.2em;
    }

    .header-titles h4 {
        font-size: 18px;
        font-weight: 300;
        color: #bbb;
        margin: 5px 0;
        line-height: 1.2em;
    }

    @media only screen and (min-width: 1025px) {
        .menu-toggle {
            display: none;
        }
    }
</style>

<header id="site_header" class="header" class:mobile-menu-hide={!isOpen}>
    <div class="header-content">
        <div class="header-photo"></div>
        <div class="header-titles">
            <h2>Venty</h2>
            <h4>Jirka Michel</h4>
        </div>
    </div>

    <MainMenu />

    <SocialLinks />

    <!-- <div class="copyrights">© {(new Date()).getFullYear()} All rights reserved.</div> -->
    {#if $store.track}
        <Spotify />
    {/if}
</header>

<!-- Mobile Navigation -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div class="menu-toggle" class:open={isOpen} onclick={toggleOpen}>
    <span></span>
    <span></span>
    <span></span>
</div>
<!-- End Mobile Navigation -->

<ArrowsNav />